module.exports = __webpack_public_path__ + "static/media/disability-placeholder.3fcb5999.webp";